import {
  DASHBOARD_KPI_REQ,
  DASHBOARD_KPI_SUCCESS,
  DASHBOARD_KPI_ERROR,
  DASHBOARD_KPI_SET,
  DASHBOARD_KPI_RESET_STATUS,
  DASHBOARD_INSIGHTS_REQ,
  DASHBOARD_INSIGHTS_SUCCESS,
  DASHBOARD_INSIGHTS_ERROR,
  DASHBOARD_INSIGHTS_SET,
  DASHBOARD_INSIGHTS_RESET_STATUS,
  ACTIVITY_EVENT_REQ,
  ACTIVITY_EVENT_SUCCESS,
  ACTIVITY_EVENT_ERROR,
  ACTIVITY_EVENT_SET,
  ACTIVITY_EVENT_RESET_STATUS
} from './kpi-statistics.type'

import ApiRest from '@/api/api-rest'
import HourlyStatistics from '@/resources/models/HourlyStatistics'
import { minutesToMilliseconds } from '@/utilities/datetime.helper'

const state = {
  executesKpiStatisticsReqStatus: '',
  executesKpiStatistics: {},
  dailyActvitiyEventReqStatus: '',
  dailyActvitiyEvent: {}
}

const getters = {
  executesKpiStatisticsReqStatus: state => state.executesKpiStatisticsReqStatus,
  executesKpiStatistics: state => state.executesKpiStatistics,
  networkKpiStatisticsReqStatus: state => state.networkKpiStatisticsReqStatus,
  networkKpiStatistics: state => state.networkKpiStatistics,
  fileKpiStatisticsReqStatus: state => state.fileKpiStatisticsReqStatus,
  fileKpiStatistics: state => state.fileKpiStatistics,
  usersKpiStatisticsReqStatus: state => state.usersKpiStatisticsReqStatus,
  usersKpiStatistics: state => state.usersKpiStatistics,
  dailyActvitiyEventReqStatus: state => state.dailyActvitiyEventReqStatus,
  dailyActvitiyEvent: state => state.dailyActvitiyEvent
}

const mutations = {
  [DASHBOARD_KPI_SET]: (state, { type, data } = {}) => {
    switch (type) {
      case 'network':
        state.networkKpiStatistics = data
        break
      case 'file':
        state.fileKpiStatistics = data
        break
      case 'users':
        state.userssKpiStatistics = data
        break
      default:
        state.executesKpiStatistics = data
    }
  },
  [DASHBOARD_KPI_REQ]: (state, type) => {
    switch (type) {
      case 'network':
        state.networkKpiStatisticsReqStatus = 'loading'
        break
      case 'file':
        state.fileKpiStatisticsReqStatus = 'loading'
        break
      case 'users':
        state.usersKpiStatisticsReqStatus = 'loading'
        break
      default:
        state.executesKpiStatisticsReqStatus = 'loading'
    }
  },
  [DASHBOARD_KPI_SUCCESS]: (state, type) => {
    switch (type) {
      case 'network':
        state.networkKpiStatisticsReqStatus = 'saved'
        break
      case 'file':
        state.fileKpiStatisticsReqStatus = 'saved'
        break
      case 'users':
        state.usersKpiStatisticsReqStatus = 'saved'
        break
      default:
        state.executesKpiStatisticsReqStatus = 'saved'
    }
  },
  [DASHBOARD_KPI_ERROR]: (state, type) => {
    switch (type) {
      case 'network':
        state.networkKpiStatisticsReqStatus = 'error'
        break
      case 'file':
        state.fileKpiStatisticsReqStatus = 'error'
        break
      case 'users':
        state.usersKpiStatisticsReqStatus = 'error'
        break
      default:
        state.executesKpiStatisticsReqStatus = 'error'
    }
  },
  [DASHBOARD_KPI_RESET_STATUS]: (state, type) => {
    switch (type) {
      case 'network':
        state.networkKpiStatisticsReqStatus = ''
        break
      case 'file':
        state.fileKpiStatisticsReqStatus = ''
        break
      case 'users':
        state.usersKpiStatisticsReqStatus = ''
        break
      default:
        state.executesKpiStatisticsReqStatus = ''
    }
  },
  [DASHBOARD_INSIGHTS_SET]: (state, { type, data } = {}) => {
    switch (type) {
      case 'network':
        state.networkInsightsStatistics = data
        break
      case 'file':
        state.fileInsightsStatistics = data
        break
      case 'users':
        state.userssInsightsStatistics = data
        break
      default:
        state.executesInsightsStatistics = data
    }
  },
  [DASHBOARD_INSIGHTS_REQ]: (state, type) => {
    switch (type) {
      case 'network':
        state.networkInsightsStatisticsReqStatus = ''
        break
      case 'file':
        state.fileInsightsStatisticsReqStatus = ''
        break
      case 'users':
        state.usersInsightsStatisticsReqStatus = ''
        break
      default:
        state.executesInsightsStatisticsReqStatus = ''
    }
  },
  [DASHBOARD_INSIGHTS_SUCCESS]: (state, type) => {
    switch (type) {
      case 'network':
        state.networkInsightsStatisticsReqStatus = 'saved'
        break
      case 'file':
        state.fileInsightsStatisticsReqStatus = 'saved'
        break
      case 'users':
        state.usersInsightsStatisticsReqStatus = 'saved'
        break
      default:
        state.executesInsightsStatisticsReqStatus = 'saved'
    }
  },
  [DASHBOARD_INSIGHTS_ERROR]: (state, type) => {
    switch (type) {
      case 'network':
        state.networkInsightsStatisticsReqStatus = 'error'
        break
      case 'file':
        state.fileInsightsStatisticsReqStatus = 'error'
        break
      case 'users':
        state.usersInsightsStatisticsReqStatus = 'error'
        break
      default:
        state.executesInsightsStatisticsReqStatus = 'error'
    }
  },
  [DASHBOARD_INSIGHTS_RESET_STATUS]: (state, type) => {
    state.executesINSIGHTSStatisticsReqStatus = ''
  },
  [ACTIVITY_EVENT_SET]: (state, data) => {
    state.dailyActvitiyEvent = data
  },
  [ACTIVITY_EVENT_REQ]: state => {
    state.dailyActvitiyEventReqStatus = 'loading'
  },
  [ACTIVITY_EVENT_SUCCESS]: state => {
    state.dailyActvitiyEventReqStatus = 'saved'
  },
  [ACTIVITY_EVENT_ERROR]: state => {
    state.dailyActvitiyEventReqStatus = 'error'
  },
  [ACTIVITY_EVENT_RESET_STATUS]: state => {
    state.dailyActvitiyEventReqStatus = ''
  }
}

const actions = {
  [DASHBOARD_KPI_REQ] (context, type) {
    let kpiUrl = `/bi/kpis/lasthour/${type}`

    return new Promise((resolve, reject) => {
      context.commit(DASHBOARD_KPI_REQ)
      ApiRest()
        .get(kpiUrl)
        .then(({ data }) => {
          data.forEach(count => {
            count.epochMinutes = minutesToMilliseconds(count.epochMinutes)
          })
          let kpi = new HourlyStatistics('', data, {
            labelProperty: 'epochMinutes',
            labelValue: 'count',
            title: `${type}`
          })

          context.commit(DASHBOARD_KPI_SET, { type: type, data: kpi })
          resolve(kpi)
        })
        .catch(errMsg => {
          context.commit(DASHBOARD_KPI_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [DASHBOARD_KPI_SUCCESS] (context, type) {
    context.commit(DASHBOARD_KPI_SUCCESS, type)
  },
  [DASHBOARD_KPI_RESET_STATUS] (context, type) {
    context.commit(DASHBOARD_KPI_RESET_STATUS, type)
  },
  [DASHBOARD_INSIGHTS_REQ] (context, { kpiType, insightsType }) {
    let insightsUrl = `/bi/insights/last24hours/${kpiType}`
    if (insightsType) {
      insightsUrl = `${insightsUrl}/${insightsType}`
    }
    return new Promise((resolve, reject) => {
      context.commit(DASHBOARD_INSIGHTS_REQ)
      ApiRest()
        .get(insightsUrl)
        .then(({ data }) => {
          context.commit(DASHBOARD_INSIGHTS_SET, { type: kpiType, data: data })
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(DASHBOARD_INSIGHTS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [DASHBOARD_INSIGHTS_SUCCESS] (context, type) {
    context.commit(DASHBOARD_INSIGHTS_SUCCESS, type)
  },
  [DASHBOARD_INSIGHTS_RESET_STATUS] (context, type) {
    context.commit(DASHBOARD_INSIGHTS_RESET_STATUS, type)
  },
  [ACTIVITY_EVENT_REQ] (context, type) {
    const todayISO = new Date(new Date().setHours(0, 0, 0, 0)).toISOString()
    let activityEventUrl = `/bi/event/count/${type}`

    return new Promise((resolve, reject) => {
      context.commit(ACTIVITY_EVENT_REQ)
      ApiRest()
        .post(activityEventUrl, {
          since: todayISO
        })
        .then(({ data }) => {
          data.forEach(count => {
            count.epochMinutes = minutesToMilliseconds(count.epochMinutes)
          })

          context.commit(ACTIVITY_EVENT_SET, data)
          context.commit(ACTIVITY_EVENT_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(ACTIVITY_EVENT_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ACTIVITY_EVENT_SUCCESS] (context) {
    context.commit(ACTIVITY_EVENT_SUCCESS)
  },
  [ACTIVITY_EVENT_RESET_STATUS] (context) {
    context.commit(ACTIVITY_EVENT_RESET_STATUS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/kpi-statistics.module.js